import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Link from '@mui/material/Link';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button'
import axios from "axios";
import * as constants from "../constants";
import logo from './../athledaLogo.png';
export default function MenuAppBar({title, signedIn}) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const signOut = () => {
        axios.post(constants.serverURL + "signOut", [],
            {
                withCredentials: true
            }).then(response => {
            window.location.href = constants.signOutURL
        }).catch((error) => {
            //console.log(error)
            window.location.href = constants.websiteURL
        })
    }
    const styles = theme => ({
        Card: {
            width: 300,
            margin: 'auto'
        },
        Media: {
            height: '100%',
            width: '100%'
        }
    });
    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar sx={{justifyContent: "space-between"}}>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>

                    {/*<Typography variant="h6" component="div" sx={{ textAlign:"left", flexGrow: 1 }}>*/}
                    {/*    {title}*/}
                    {/*</Typography>*/}
                    <Box
                        component='img'
                        size="large"
                        sx={{ height: 30 }}
                        src={logo}
                    />
                    <Typography variant="h6" component="div" sx={{ textAlign:"left", flexGrow: 1 }}>
                        <Link style={{ textDecoration: 'none' }} href={constants.mainURL}>{"The athLEDA Foundation"}</Link>
                    </Typography>
                    {signedIn && (
                        <div>
                            <Button variant='outlined' onClick={signOut}>Sign Out</Button>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleClose}>Profile</MenuItem>
                                <MenuItem onClick={handleClose}>My account</MenuItem>
                            </Menu>
                        </div>
                    )}
                </Toolbar>
            </AppBar>
        </Box>
    );
}